export default __webpack_public_path__ + "static/media/agent-photo.bb4886ac.svg";